import CryptoJS from "crypto-js";
export const encrypt = (
  value: string | null,
  encryptionKey: string | null
): string | null => {
  if (value != null && encryptionKey != null) {
    const key = CryptoJS.enc.Utf8.parse(encryptionKey);
    let encrypted = CryptoJS.AES.encrypt(value.trim(), key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted.toString();
  }
  return null;
};
